import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceBase } from '../service.base';
import { AcceptProposalProduct, ConsignmentProposalProduct, ConsignmentProposalRequest, FetchConsignmentsRequestParam, ProposalHistoryResponse } from '../consignment.service';
import { AuthService, ResponseObject } from '../auth.service';

@Injectable({
    providedIn: 'root'
})
export class ProposalService extends ServiceBase {
    private _api = '/Proposals';

    constructor(private http: HttpClient, authService: AuthService) {
        super(authService);
    }

    public sendConsignmentProposal(data: ConsignmentProposalRequest): Observable<ResponseObject> {
        const httpOptions = this.RequestHeaders();
        const method: string = '/proposal';
        const url: string = environment.BASE_API_PATH + this._api + method;
        return this.http.post<ResponseObject>(url, data, httpOptions);
    }

    public getConsignmentProposalProducts(consignmentProposalId: string): Observable<ConsignmentProposalProduct[]> {
        var httpOptions = this.RequestHeaders();
        const method: string = '/' + consignmentProposalId + '/proposal-products';
        const url: string = environment.BASE_API_PATH + this._api + method;
        return this.http.get<ConsignmentProposalProduct[]>(url, httpOptions);
    }


    public createConsignment(proposalId: string): Observable<ResponseObject> {
        const httpOptions = this.RequestHeaders();
        const method = `/create-consignment/${proposalId}`;
        const url = environment.BASE_API_PATH + this._api + method;
        return this.http.post<ResponseObject>(url, {}, httpOptions);
    }

    public acceptConsignmentProposal(consignmentProposalId: string | undefined, comment: string | null, acceptProposalProductData: AcceptProposalProduct): Observable<ResponseObject> {
        const httpOptions = this.RequestHeaders();
        const method: string = `/${consignmentProposalId}/accept-proposal`;
        const url: string = environment.BASE_API_PATH + this._api + method;
        if (comment !== null) {
            acceptProposalProductData.Comment = comment;
        }
        return this.http.post<ResponseObject>(url, acceptProposalProductData, httpOptions);
    }

    public showConsignmentProposalLogHistory(consignmentId: string): Observable<ProposalHistoryResponse[]> {
        const httpOptions = this.RequestHeaders();
        const method: string = '/ProposalActivityLog/' + consignmentId;
        const url: string = environment.BASE_API_PATH + this._api + method;
        return this.http.get<ProposalHistoryResponse[]>(url, httpOptions);
    }

    public ViewConsignmentProposal(filters: FetchConsignmentsRequestParam = {}): Observable<ConsignmentProposalRequest[]> {
        const httpOptions = this.RequestHeaders();
        const method: string = '/view-proposals';
        const url: string = environment.BASE_API_PATH + this._api + method;
        return this.http.post<ConsignmentProposalRequest[]>(url, filters, httpOptions);
    }

}
